import { ChangeEvent, KeyboardEvent, useState } from 'react'
import { MdSearch } from 'react-icons/md'

import { Button } from 'src/components/atoms/Button'
import { DefaultInput } from 'src/components/atoms/DefaultInput'
import { IconButton } from 'src/components/atoms/IconButton'

import { FormFieldTypes } from 'src/types/form'

const ENTER_CODE = 'Enter'

export interface SearchControlsProps {
  currentSearchQuery: string
  onClear: () => void
  onSearch: (searchQuery: string) => void
  showOnClear?: boolean
}

export const SearchControls = ({
  currentSearchQuery,
  onClear,
  onSearch,
  showOnClear = true
}: SearchControlsProps) => {
  const [searchQuery, setSearchQuery] = useState<string>(currentSearchQuery)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.code === ENTER_CODE) onSearch(searchQuery)
  }

  const handleSearch = () => {
    onSearch(searchQuery)
  }

  const handleClear = () => {
    onClear()
    setSearchQuery('')
  }

  return (
    <div className='items-center'>
      <label className='font-bold' htmlFor='searchControls'>
        Search:
      </label>
      <div className='flex'>
        <DefaultInput
          className='mb-0 rounded-r-none border-r-0'
          id='searchControls'
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          type={FormFieldTypes.search}
          value={searchQuery}
        />
        <IconButton
          icon={MdSearch}
          className='border-l-none rounded-l-none bg-none rounded-lg'
          color='primary-inverted'
          onClick={handleSearch}
          ariaLabel='Search'
        />
        {showOnClear ? (
          <Button
            className='min-w-fit ml-2'
            color='secondary'
            disabled={!currentSearchQuery}
            onClick={handleClear}
          >
            Clear search query
          </Button>
        ) : null}
      </div>
    </div>
  )
}
